var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"rounded shadow px-1",class:{
    'bg-primary-light': _vm.status === 'draft',
    'bg-secondary-light': _vm.status === 'scheduled',
    'bg-warning': _vm.status === 'queued',
    'bg-success': _vm.status === 'sent',
    'bg-error text-white': _vm.status === 'error' || _vm.status === 'trash',
  },domProps:{"textContent":_vm._s(_vm.status)}})}
var staticRenderFns = []

export { render, staticRenderFns }